import { EWizardLegendItemState } from "@similarweb/ui-components";

import type {
    ICampaignsWizardState,
    ICampaignsWizardStepProps,
} from "app/components/campaigns/campaigns-wizard/CampaignsWizardConsts";
import { ECampaignPagesError } from "app/components/campaigns/campaigns-wizard/CampaignsWizardConsts";
import { DEFAULT_SEARCH_ENGINE_FULL } from "app/components/campaigns/searchEngine/SearchEngineUtils";
import { translate } from "app/filters/i18nFilter";
import { BPCampaignsFields } from "app/pages/digital-marketing/brand-monitoring-campaigns/wizard/BPCampaignsWizard.types";
import { REGULAR_FOOTER_WIDTH } from "app/pages/digital-marketing/keywords-campaigns/wizard/constants";

export const CREATE_CAMPAIGN_WIZARD_STATE = "brandmonitoring.wizard";
const selectedSiteSteps = {
    selectedSite: {
        value: {
            site: null,
            metadata: null,
        },
        hasError: true,
    },
    projectName: {
        value: null,
        hasError: true,
    },
    email: {
        value: null,
        hasError: false,
    },
};
const selectSiteStep: ICampaignsWizardStepProps = {
    fields: selectedSiteSteps,
    legendData: {
        get title() {
            return translate("paid.brandMonitoringCampaign.wizard.navigation.selectSiteStep.title");
        },
        itemState: EWizardLegendItemState.NOT_VISITED,
        get clickableItemTooltip() {
            return translate("paid.brandMonitoringCampaign.wizard.navigation.selectSiteStep.tooltipClickable");
        },
        get disabledItemTooltip() {
            return translate("paid.brandMonitoringCampaign.wizard.navigation.common.tooltipDisabled");
        },
    },
    pageError: ECampaignPagesError.EMPTY_OR_DUPLICATE_SITE_STEP_ERROR,
    shouldShowKeywordCounter: false,
    footerWidth: REGULAR_FOOTER_WIDTH,
};
const selectedSearchEngines = {
    searchEngines: {
        value: [DEFAULT_SEARCH_ENGINE_FULL],
        hasError: false,
    },
    lastSearchEngineID: {
        value: 1,
        hasError: false,
    },
};
const searchEnginesStep: ICampaignsWizardStepProps = {
    fields: selectedSearchEngines,
    legendData: {
        get title() {
            return translate("paid.brandMonitoringCampaign.wizard.navigation.searchEnginesStep.title");
        },
        itemState: EWizardLegendItemState.NOT_VISITED,
        get clickableItemTooltip() {
            return translate("paid.brandMonitoringCampaign.wizard.navigation.searchEnginesStep.tooltipClickable");
        },
        get disabledItemTooltip() {
            return translate("paid.brandMonitoringCampaign.wizard.navigation.common.tooltipDisabled");
        },
    },
    pageError: undefined,
    shouldShowKeywordCounter: false,
    footerWidth: REGULAR_FOOTER_WIDTH,
};
const selectedKeywords = {
    amountOfUsedKeywordsCurrentCampaign: { value: 0, hasError: false },
    keywords: {
        value: [],
        hasError: false,
    },
};
const keywordsStep: ICampaignsWizardStepProps = {
    fields: selectedKeywords,
    legendData: {
        get title() {
            return translate("paid.brandMonitoringCampaign.wizard.navigation.keywordsStep.title");
        },
        itemState: EWizardLegendItemState.NOT_VISITED,
        get clickableItemTooltip() {
            return translate("paid.brandMonitoringCampaign.wizard.navigation.keywordsStep.tooltipClickable");
        },
        get disabledItemTooltip() {
            return translate("paid.brandMonitoringCampaign.wizard.navigation.common.tooltipDisabled");
        },
    },
    pageError: ECampaignPagesError.EMPTY_KEYWORDS_STEP_ERROR,
    shouldShowKeywordCounter: true,
    footerWidth: REGULAR_FOOTER_WIDTH,
};
export const defaultWizardState: ICampaignsWizardState = {
    pages: [selectSiteStep, searchEnginesStep, keywordsStep],
    campaignsFields: BPCampaignsFields,
};
export const PERFORMANCE_ADD_ON_MUTUAL_ASSETS = "api/PerformanceAddOn/MutualAssets";
export const CRUD_BRAND_MONITORING_CAMPAIGN_URL = "api/brandMonitorCampaigns/getCampaign";
export const CRUD_CAMPAIGN_URL = "api/brandMonitorCampaigns";
export const SUBSCRIBE_CAMPAIGN_URL = `${CRUD_CAMPAIGN_URL}/subscribe`;
export const UNSUBSCRIBE_CAMPAIGN_URL = `${CRUD_CAMPAIGN_URL}/unsubscribe`;
export const BRAND_MONITORING_CAMPAIGN_HOME_STATE = "brandmonitoring.home";

export const SETTINGS_NAVIGATION_STATE = "brandmonitoring.settings";

export const BRAND_MONITORING_CAMPAIGN_CONFIG_ID = "BrandMonitor";
